/*
 * Truffle LP Black Week (tlp-*). Vanilla JS, inga bibliotek.
 * Varje del letar upp sina element via data-attribut, initieras på DOMContentLoaded och
 * igen på shopify:section:load (temaeditorn), och städar på shopify:section:unload.
 * Griden (data-lbw-tabs) och stickyn (data-lbw-sticky) sköts av lbw.js.
 */
(function () {
  if (window.TLP_LOADED) return;
  window.TLP_LOADED = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cleanups = new Map();
  var MONTHS = ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'];
  var MONTHS_SHORT = ['JAN', 'FEB', 'MAR', 'APR', 'MAJ', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEC'];

  function addCleanup(el, fn) {
    var list = cleanups.get(el) || [];
    list.push(fn);
    cleanups.set(el, list);
  }

  function cleanupWithin(scope) {
    cleanups.forEach(function (list, el) {
      if (scope === document || scope === el || scope.contains(el)) {
        list.forEach(function (fn) { fn(); });
        cleanups.delete(el);
      }
    });
  }

  function each(scope, selector, fn) {
    if (scope !== document && scope.matches && scope.matches(selector)) fn(scope);
    scope.querySelectorAll(selector).forEach(fn);
  }

  function scrollBehavior() {
    return reducedMotion.matches ? 'auto' : 'smooth';
  }

  function pad(n) {
    return ('0' + n).slice(-2);
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- 1. Kampanjslut (samma som lbw.js) ---------- */

  // Förskjutningen (ms) mellan UTC och tidszonen vid tidpunkten t.
  function zoneOffset(t, timeZone) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date(t)).forEach(function (p) { parts[p.type] = p.value; });
    var asUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
    return asUtc - Math.floor(t / 1000) * 1000;
  }

  // "2026-12-01T23:59" i lokal tid för timeZone → UTC-millisekunder. Sommartid hanteras.
  function zonedToUtc(local, timeZone) {
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(local);
    if (!m) return null;
    var y = +m[1], mo = +m[2] - 1, d = +m[3], h = +m[4], mi = +m[5], s = +(m[6] || 0);
    var guess = Date.UTC(y, mo, d, h, mi, s);
    var check = new Date(guess);
    if (check.getUTCFullYear() !== y || check.getUTCMonth() !== mo || check.getUTCDate() !== d ||
        check.getUTCHours() !== h || check.getUTCMinutes() !== mi) return null;
    try {
      var offset = zoneOffset(guess, timeZone);
      var t = guess - offset;
      var corrected = zoneOffset(t, timeZone);
      return corrected === offset ? t : guess - corrected;
    } catch (e) {
      return null;
    }
  }

  // Liquid ger "+0100", som Safari inte tolkar: gör om till "+01:00".
  function parseIso(raw) {
    if (!raw) return null;
    var t = Date.parse(raw.replace(/([+-]\d\d)(\d\d)$/, '$1:$2'));
    return isNaN(t) ? null : t;
  }

  function readCampaign() {
    var el = document.querySelector('[data-lbw-campaign]');
    if (!el) return null;
    var raw = el.getAttribute('data-end');
    if (!raw) return null;
    var tz = el.getAttribute('data-tz');
    var end = tz ? zonedToUtc(raw, tz) : parseIso(raw);
    if (end === null || isNaN(end)) return null;
    return { end: end, timeZone: tz || 'Europe/Stockholm' };
  }

  // Dag och månad (0–11) för t i tidszonen.
  function dayMonth(t, timeZone) {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: timeZone, day: 'numeric', month: 'numeric' })
        .formatToParts(new Date(t)).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) {
      var d = new Date(t);
      parts = { day: d.getDate(), month: d.getMonth() + 1 };
    }
    return { day: +parts.day, month: +parts.month - 1 };
  }

  // "2d 14h 32m", under 24 h "14h 32m", under 1 h "32m".
  function formatShort(ms) {
    var totalMinutes = Math.max(1, Math.floor(ms / 60000));
    var days = Math.floor(totalMinutes / 1440);
    var hours = pad(Math.floor((totalMinutes % 1440) / 60));
    var minutes = pad(totalMinutes % 60);
    if (totalMinutes < 60) return minutes + 'm';
    if (totalMinutes < 1440) return hours + 'h ' + minutes + 'm';
    return days + 'd ' + hours + 'h ' + minutes + 'm';
  }

  /* ---------- 2. Slutdatum i text och i baren ---------- */

  // [SLUTDATUM] → "1 december". Utan kampanjslut står hakparentesen kvar.
  function renderEndDates(campaign) {
    var label = null;
    if (campaign) {
      var dm = dayMonth(campaign.end, campaign.timeZone);
      label = dm.day + ' ' + MONTHS[dm.month];
    }
    document.querySelectorAll('[data-tlp-enddate]').forEach(function (el) {
      if (label) el.textContent = label;
      el.classList.add('is-ready');
    });
  }

  function renderBars(campaign, now) {
    document.querySelectorAll('[data-tlp-bar]').forEach(function (bar) {
      var part = bar.querySelector('[data-tlp-bar-end]');
      var text = bar.querySelector('[data-tlp-bar-end-text]');
      if (!part || !text) return;
      var remaining = campaign ? campaign.end - now : 0;
      var sep = bar.querySelector('[data-tlp-sep-after-end]');
      if (!campaign || remaining <= 0) {
        part.hidden = true;
        if (sep) sep.hidden = true;
        return;
      }
      if (sep) sep.hidden = false;
      if (bar.getAttribute('data-countdown') === 'true') {
        text.textContent = formatShort(remaining);
      } else {
        var dm = dayMonth(campaign.end, campaign.timeZone);
        text.textContent = 'SLUTAR ' + dm.day + ' ' + MONTHS_SHORT[dm.month];
      }
      part.hidden = false;
    });
  }

  /* ---------- 3. Nedräkning med rutor ---------- */

  function countdownEnd(el, campaign) {
    var own = el.getAttribute('data-ends');
    if (own) return parseIso(own);
    return campaign ? campaign.end : null;
  }

  function renderCountdowns(campaign, now) {
    document.querySelectorAll('[data-tlp-countdown]').forEach(function (el) {
      var end = countdownEnd(el, campaign);
      var remaining = end === null ? 0 : end - now;
      if (remaining <= 0) {
        el.hidden = true;
        return;
      }
      var total = Math.ceil(remaining / 1000);
      var values = {
        d: Math.floor(total / 86400),
        h: Math.floor((total % 86400) / 3600),
        m: Math.floor((total % 3600) / 60),
        s: total % 60
      };
      el.querySelectorAll('[data-unit]').forEach(function (box) {
        var unit = box.getAttribute('data-unit');
        box.querySelector('b').textContent = pad(values[unit]);
        if (unit === 'd') box.hidden = values.d === 0;
      });
      el.hidden = false;
    });
  }

  /* ---------- 4. Veckans deal ---------- */

  function dealEnd(section) {
    if (section.hasAttribute('data-ends')) return parseIso(section.getAttribute('data-ends'));
    if (section.hasAttribute('data-ends-local')) {
      return zonedToUtc(section.getAttribute('data-ends-local'), section.getAttribute('data-tz') || 'Europe/Stockholm');
    }
    return null;
  }

  function renderDeals(now) {
    document.querySelectorAll('[data-tlp-deal]').forEach(function (section) {
      var end = dealEnd(section);
      var times = section.querySelectorAll('[data-tlp-deal-time]');
      if (end === null) {
        times.forEach(function (t) { t.hidden = true; });
        return;
      }
      var remaining = end - now;
      if (remaining <= 0) {
        // Sidan kan vara cachad: dealen har gått ut, så sektionen döljs.
        section.hidden = true;
        return;
      }
      var total = Math.ceil(remaining / 1000);
      var days = Math.floor(total / 86400);
      var label = pad(Math.floor((total % 86400) / 3600)) + 'h ' +
        pad(Math.floor((total % 3600) / 60)) + 'm ' + pad(total % 60) + 's';
      if (days > 0) label = days + 'd ' + label;
      times.forEach(function (t) {
        var text = t.querySelector('[data-tlp-deal-time-text]');
        if (text) text.textContent = label;
        t.hidden = false;
      });
    });
  }

  /* ---------- Gemensam klocka ---------- */

  var clock = null;

  function tick() {
    var campaign = readCampaign();
    var now = Date.now();
    renderCountdowns(campaign, now);
    renderBars(campaign, now);
    renderDeals(now);
  }

  function startClock() {
    clearInterval(clock);
    renderEndDates(readCampaign());
    tick();
    if (document.querySelector('[data-tlp-countdown], [data-tlp-bar], [data-tlp-deal]')) {
      clock = setInterval(tick, 1000);
    }
  }

  /* ---------- 5. Flikar (boosters) ---------- */

  function initTabs(container, onChange) {
    var tabs = Array.prototype.slice.call(container.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function activate(tab, focus) {
      tabs.forEach(function (t) {
        var selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.tabIndex = selected ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) tab.focus();
      if (onChange) onChange(tab);
    }

    function onClick(event) {
      var tab = event.target.closest('[role="tab"]');
      if (tab && container.contains(tab)) activate(tab, false);
    }

    function onKeydown(event) {
      var index = tabs.indexOf(event.target);
      if (index === -1) return;
      var next = null;
      if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
      else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
      else if (event.key === 'Home') next = tabs[0];
      else if (event.key === 'End') next = tabs[tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      activate(next, true);
    }

    container.addEventListener('click', onClick);
    container.addEventListener('keydown', onKeydown);
    addCleanup(container, function () {
      container.removeEventListener('click', onClick);
      container.removeEventListener('keydown', onKeydown);
    });
  }

  /* ---------- 6. Boosters: flikar och "Lägg till" ---------- */

  function initBoosters(section) {
    var more = section.querySelector('[data-tlp-more]');
    var status = section.querySelector('[data-tlp-status]');
    var texts = {
      add: section.getAttribute('data-text-add') || '',
      added: section.getAttribute('data-text-added') || '',
      retry: section.getAttribute('data-text-retry') || '',
      soldOut: section.getAttribute('data-text-sold-out') || ''
    };
    var timers = [];

    var tablist = section.querySelector('[role="tablist"]');
    if (tablist) {
      initTabs(section, function (tab) {
        if (!more) return;
        var n = parseInt(tab.getAttribute('data-more'), 10) || 0;
        more.textContent = (more.getAttribute('data-template') || '').replace('[antal]', n);
        more.hidden = n <= 0;
      });
    }

    function setButton(button, text, revert) {
      button.textContent = text;
      if (status) status.textContent = text;
      if (revert) {
        timers.push(setTimeout(function () {
          button.textContent = texts.add;
          button.disabled = false;
        }, 2000));
      }
    }

    function onClick(event) {
      var button = event.target.closest('.tlp-booster__add[data-variant-id]');
      if (!button || !section.contains(button) || button.disabled) return;
      button.disabled = true;
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +button.getAttribute('data-variant-id'), quantity: 1 }] })
      })
        .then(function (response) {
          if (response.ok) {
            setButton(button, texts.added, true);
            // Temat uppdaterar header och drawer. Drawern öppnas inte.
            document.documentElement.dispatchEvent(
              new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: false } })
            );
          } else if (response.status === 422) {
            setButton(button, texts.soldOut, false);
          } else {
            setButton(button, texts.retry, true);
          }
        })
        .catch(function () {
          setButton(button, texts.retry, true);
        });
    }

    section.addEventListener('click', onClick);
    addCleanup(section, function () {
      section.removeEventListener('click', onClick);
      timers.forEach(clearTimeout);
    });
  }

  /* ---------- 7. Erbjudanden: [antal] i knappen och tillfälliga chips ---------- */

  function selectedChip(grid) {
    return grid.querySelector('[role="tab"][aria-selected="true"]');
  }

  function updateShowAll(grid) {
    var link = grid.querySelector('[data-tlp-show-all]');
    var chip = selectedChip(grid);
    if (!link || !chip) return;
    var count = chip.getAttribute('data-count') || '';
    link.textContent = (link.getAttribute('data-template') || '').replace('[antal]', count);
  }

  function originalChips(grid) {
    return Array.prototype.slice.call(grid.querySelectorAll('[role="tab"]:not([data-tlp-temp])'));
  }

  function selectTemp(grid, temp, focus) {
    activateChip(grid, temp);
    if (focus) temp.focus();
  }

  // Samma tillstånd som lbw.js activate() sätter. lbw.js läser tillståndet på nytt vid varje
  // klick, så det fungerar även innan lbw.js har startat (sidladdning med ?tlp_filter=).
  function activateChip(grid, chip) {
    grid.querySelectorAll('[role="tab"]').forEach(function (t) {
      var selected = t === chip;
      t.setAttribute('aria-selected', selected ? 'true' : 'false');
      t.tabIndex = selected ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    var more = grid.querySelector('[data-lbw-show-all]');
    if (more) {
      var url = chip.getAttribute('data-url');
      if (url) more.href = url;
      more.hidden = !url;
    }
    updateShowAll(grid);
  }

  function deselectTemps(grid) {
    grid.querySelectorAll('[data-tlp-temp]').forEach(function (t) {
      t.setAttribute('aria-selected', 'false');
      t.tabIndex = -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
    });
  }

  function initGrid(grid) {
    function onClick(event) {
      var tab = event.target.closest('[role="tab"]');
      if (!tab || !grid.contains(tab)) return;
      if (tab.hasAttribute('data-tlp-temp')) selectTemp(grid, tab, false);
      else deselectTemps(grid);
      updateShowAll(grid);
    }

    // lbw.js bygger sin flikslista en gång, så piltangenterna för tillfälliga chips sköts här.
    function onKeydown(event) {
      var tab = event.target.closest('[role="tab"]');
      if (!tab || !grid.contains(tab)) return;
      if (!tab.hasAttribute('data-tlp-temp')) {
        if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].indexOf(event.key) !== -1) {
          setTimeout(function () { deselectTemps(grid); updateShowAll(grid); }, 0);
        }
        return;
      }
      var originals = originalChips(grid);
      if (!originals.length) return;
      var next = null;
      if (event.key === 'ArrowRight' || event.key === 'Home') next = originals[0];
      else if (event.key === 'ArrowLeft') next = originals[originals.length - 1];
      if (!next) return;
      event.preventDefault();
      next.click();
      next.focus();
    }

    grid.addEventListener('keydown', onKeydown);
    // Klick lyssnas på dokumentet, så att lbw.js (på sektionen) hinner först.
    document.addEventListener('click', onClick);
    addCleanup(grid, function () {
      grid.removeEventListener('keydown', onKeydown);
      document.removeEventListener('click', onClick);
    });
    updateShowAll(grid);
  }

  function scrollToGrid(target) {
    if (target) target.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
  }

  var pendingFilters = {};

  // Aktiverar kollektionens chip i griden, eller hämtar en panel och lägger till en
  // tillfällig chip. Returnerar ett Promise med true när en tillfällig chip aktiverades.
  function applyFilter(handle, label) {
    var grid = document.querySelector('[data-tlp-grid]');
    if (!grid) return Promise.resolve(false);

    var chip = null;
    grid.querySelectorAll('[role="tab"][data-collection]').forEach(function (c) {
      if (!chip && c.getAttribute('data-collection') === handle) chip = c;
    });
    if (chip) {
      activateChip(grid, chip);
      return Promise.resolve(chip.hasAttribute('data-tlp-temp'));
    }

    if (pendingFilters[handle]) return pendingFilters[handle];
    var url = root() + 'collections/' + encodeURIComponent(handle) + '?section_id=tlp-grid-panel';
    pendingFilters[handle] = fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('status ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('.tlp-grid__list');
        var chips = grid.querySelector('[role="tablist"]');
        if (!list || !list.children.length || !chips) return false;

        var index = grid.querySelectorAll('[role="tab"]').length + 100;
        var tabId = (grid.getAttribute('data-tab-prefix') || 'tlp-tab-') + index;
        var panelId = (grid.getAttribute('data-panel-prefix') || 'tlp-panel-') + index;

        var temp = document.createElement('button');
        temp.type = 'button';
        temp.className = 'tlp-chip';
        temp.setAttribute('role', 'tab');
        temp.id = tabId;
        temp.setAttribute('aria-controls', panelId);
        temp.setAttribute('aria-selected', 'false');
        temp.tabIndex = -1;
        temp.setAttribute('data-tlp-temp', '');
        temp.setAttribute('data-collection', handle);
        temp.setAttribute('data-count', list.getAttribute('data-count') || list.children.length);
        temp.setAttribute('data-url', root() + 'collections/' + handle);
        temp.setAttribute('data-track', 'tlp_chip_' + handle);
        temp.textContent = label || handle;
        chips.appendChild(temp);

        var panel = document.createElement('div');
        panel.className = 'tlp-grid__panel';
        panel.id = panelId;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabId);
        panel.tabIndex = 0;
        panel.hidden = true;
        panel.appendChild(document.importNode(list, true));
        var panels = grid.querySelectorAll('.tlp-grid__panel');
        var last = panels[panels.length - 1];
        last.parentNode.insertBefore(panel, last.nextSibling);

        selectTemp(grid, temp, false);
        return true;
      })
      .catch(function () {
        // T.ex. en opublicerad kollektion (404): bara scroll till griden.
        return false;
      })
      .then(function (result) {
        delete pendingFilters[handle];
        return result;
      });
    return pendingFilters[handle];
  }

  function onFilterLinkClick(event) {
    var link = event.target.closest('[data-tlp-filter-link]');
    if (!link) return;
    event.preventDefault();
    var grid = document.querySelector('[data-tlp-grid]') || document.getElementById('alla');
    applyFilter(link.getAttribute('data-collection'), link.getAttribute('data-label'));
    scrollToGrid(grid);
  }

  // ?tlp_filter=handle eller #alla?filter=handle vid sidladdning.
  function filterFromUrl() {
    var handle = null;
    var fromQuery = false;
    try {
      handle = new URLSearchParams(window.location.search).get('tlp_filter');
      if (handle) fromQuery = true;
    } catch (e) {}
    if (!handle) {
      var m = /[?&]filter=([^&]+)/.exec(window.location.hash);
      if (m) handle = decodeURIComponent(m[1]);
    }
    if (!handle) return;
    var grid = document.querySelector('[data-tlp-grid]');
    if (!grid) return;
    var source = document.querySelector('[data-tlp-filter-link][data-collection="' + handle.replace(/"/g, '') + '"]');
    applyFilter(handle, source ? source.getAttribute('data-label') : null).then(function (temp) {
      if (temp && fromQuery && window.history && window.history.replaceState) {
        var params = new URLSearchParams(window.location.search);
        params.delete('tlp_filter');
        var query = params.toString();
        window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + '#alla');
      }
      scrollToGrid(grid);
    });
  }

  /* ---------- 8. Egen header och egen bar ---------- */

  function updateOffsets() {
    var bar = document.querySelector('.tlp-bar--sticky');
    var header = document.querySelector('.tlp-header--sticky');
    var html = document.documentElement;
    var barHeight = bar ? bar.offsetHeight : 0;
    html.style.setProperty('--tlp-bar-sticky-h', barHeight + 'px');
    if (bar || header) {
      var theme = parseFloat(getComputedStyle(html).getPropertyValue('--theme-sticky-header-height')) || 0;
      html.style.setProperty('--tlp-header-offset', (theme + barHeight + (header ? header.offsetHeight : 0)) + 'px');
    } else {
      html.style.removeProperty('--tlp-header-offset');
    }
  }

  function initHeader(header) {
    var cart = header.querySelector('[data-tlp-cart]');
    var count = header.querySelector('[data-tlp-cart-count]');

    function onCartClick(event) {
      if (!document.querySelector('.cart-drawer')) return;
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true }));
    }

    function onCartChanged() {
      if (!count) return;
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          count.textContent = data.item_count;
          count.hidden = !data.item_count;
        })
        .catch(function () {});
    }

    if (cart) cart.addEventListener('click', onCartClick);
    document.addEventListener('theme:cartchanged', onCartChanged);
    addCleanup(header, function () {
      if (cart) cart.removeEventListener('click', onCartClick);
      document.removeEventListener('theme:cartchanged', onCartChanged);
    });
  }

  var resizeObserver = null;

  function initStickyOffsets() {
    if (resizeObserver) resizeObserver.disconnect();
    resizeObserver = null;
    var els = document.querySelectorAll('.tlp-bar--sticky, .tlp-header--sticky');
    updateOffsets();
    if (!els.length || !window.ResizeObserver) return;
    resizeObserver = new ResizeObserver(updateOffsets);
    els.forEach(function (el) { resizeObserver.observe(el); });
  }

  /* ---------- Start och temaeditorn ---------- */

  // Ett fel i en del (t.ex. en gammal webbläsare) får inte stoppa de andra.
  function safely(fn, el) {
    try {
      fn(el);
    } catch (e) {
      if (window.console) console.error('tlp:', e);
    }
  }

  function initSection(scope) {
    each(scope, '[data-tlp-boosters]', function (el) { safely(initBoosters, el); });
    each(scope, '[data-tlp-grid]', function (el) { safely(initGrid, el); });
    each(scope, '[data-tlp-header]', function (el) { safely(initHeader, el); });
  }

  // Klockan och offseten läser hela sidan, så de startas om när en sektion ändras.
  function initPage() {
    cleanups.forEach(function (list, el) {
      if (el.isConnected) return;
      list.forEach(function (fn) { fn(); });
      cleanups.delete(el);
    });
    safely(startClock);
    safely(initStickyOffsets);
  }

  function start() {
    initSection(document);
    initPage();
    document.addEventListener('click', onFilterLinkClick);
    safely(filterFromUrl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
    initPage();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupWithin(event.target);
    // Sektionen tas bort efter händelsen: vänta en tick och läs om sidan.
    setTimeout(initPage, 0);
  });
})();
